import { HttpWrapper, AppConfig } from "../../../../core";
import { PostExportModel } from "../../../../shared/export/post.export.model";
import { SchemasListResponseModel, SchemasDetailModel } from "../models";



export class SchemasService {
  private wrapper: HttpWrapper;
  constructor() {
    this.wrapper = new HttpWrapper();
  }

  getSchemasList(currentPage: number, pageSize: number, sortBy: string, sortOrder: boolean, filters: any) {
    return this.wrapper.post<SchemasListResponseModel>(AppConfig.apiEndpoint + '/v1/schemas/list?current_page=' + currentPage + '&page_size=' + pageSize + '&sort_by=' + sortBy + '&is_desc=' + sortOrder, { filters: filters });
  }

  getSchemasById(id: number) {
    return this.wrapper.get<SchemasDetailModel>(AppConfig.apiEndpoint + '/v1/schemas/' + id);
  }  

  exportSchemas(exportData?: PostExportModel) {
    return this.wrapper.getFileByPost(AppConfig.apiEndpoint + '/v1/schemas/export', exportData);
  }


}